import { VStack } from '@chakra-ui/react';
import WholesalerGeneralDetails from './accordionSections/WholesalerGeneralDetails';
import CompanyGeneralContact from 'pages/organisations/companies/v5/tabs/accordionSections/CompanyGeneralContact';
import WholesalerName from './formFields/WholesalerName';
import DefaultPlan from './formFields/DefaultPlan';
import BusinessNumber from 'pages/organisations/companies/v5/tabs/formFields/BusinessNumber';
import PrimaryContactName from 'pages/organisations/companies/v5/tabs/formFields/PrimaryContactName';
import PrimaryContactPhone from 'pages/organisations/companies/v5/tabs/formFields/PrimaryContactPhone';
import PrimaryContactEmail from 'pages/organisations/companies/v5/tabs/formFields/PrimaryContactEmail';
import AccountsContactEmail from 'pages/organisations/companies/v5/tabs/formFields/AccountsContactEmail';
import SupportContactEmail from 'pages/organisations/companies/v5/tabs/formFields/SupportContactEmail';

const WholesalerGeneral = ({
    darkMode,
    errors,
    touched,
    isAddMode,
    defaultPlansData,
}) => {
    return (
        <VStack spacing={1} align="stretch">
            {isAddMode && (
                <>
                    <WholesalerName
                        key="wholesalerName"
                        errors={errors}
                        darkMode={darkMode}
                        isAddMode={isAddMode}
                    />
                    <DefaultPlan
                        key="defaultPlan"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                        defaultPlansData={defaultPlansData}
                    />
                    <BusinessNumber
                        key="businessNumber"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                    <PrimaryContactName
                        key="primaryContactName"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                    <PrimaryContactPhone
                        key="primaryContactPhone"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                    <PrimaryContactEmail
                        key="primaryContactEmail"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                    <AccountsContactEmail
                        key="accountsContactEmail"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                    <SupportContactEmail
                        key="supportContactEmail"
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                </>
            )}
            {!isAddMode && (
                <>
                    <WholesalerGeneralDetails
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                    <CompanyGeneralContact
                        errors={errors}
                        touched={touched}
                        darkMode={darkMode}
                    />
                </>
            )}
        </VStack>
    );
};

export default WholesalerGeneral;
